import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
  Paper,
  Stack,
  Button,
  Divider,
  Card,
  CardContent,
  Chip,
  Alert,
  AlertTitle,
  Pagination,
  Select,
  MenuItem,
} from "@mui/material";
import { useEffect, useState } from "react";

const ProductSelectionStep = ({
  products,
  onBack,
  onComplete,
  totalCount,
  setPage,
  page,
  setPageSize,
  pageSize,
  getCategoryProducts,
  selectedProducts,
  setSelectedProducts,
}) => {
  const [selectAll, setSelectAll] = useState();
  const [newPage, setNewPage] = useState(0);
  const productsPerPage = pageSize;
  const pageCount = Math.ceil(totalCount / productsPerPage);
  const displayedProducts = products.slice(0, productsPerPage);
  console.log(products);

  const handleDisplayedProducts = () => {
    const allDisplayedProductIds = [];

    displayedProducts.forEach((p) => {
      // Check if the conditions are met for adding the product ID

      if (p.productPlaces.length == 0) {
        if (p.productPlaceTransfers.length > 0) {
          if (
            p.productPlaces.length == 0 &&
            p.productPlaceTransfers[0]?.status == 9
          ) {
            allDisplayedProductIds.push(p.id);
          }
        } else {
          allDisplayedProductIds.push(p.id);
        }
      }
    });

    return allDisplayedProductIds;
  };
  let allDisplayedProductIds = handleDisplayedProducts();

  const handleProductChange = (productId, checked) => {
    setSelectedProducts((prev) =>
      checked ? [...prev, productId] : prev.filter((id) => id !== productId)
    );
  };

  const handleSelectAll = (checked) => {
    setSelectAll(checked);
    setSelectedProducts((prev) => {
      const otherPageSelections = prev.filter(
        (id) => !allDisplayedProductIds.includes(id)
      );
      return checked
        ? [...otherPageSelections, ...allDisplayedProductIds]
        : otherPageSelections;
    });
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    setNewPage(newPage);
  };

  const handlePageSize = (event, value) => {
    setPageSize(value);
  };

  const handleItemCheckbox = (product) => {
    if (product.productPlaces.length > 0) {
      return true;
    }
    if (product.productPlaceTransfers.length > 0) {
      if (product.productPlaceTransfers[0]?.status == 9) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  const isAllCurrentPageSelected =
    allDisplayedProductIds.length > 0 &&
    allDisplayedProductIds.every((id) => selectedProducts.includes(id));
  useEffect(() => {
    if (newPage == page) {
      getCategoryProducts();
    }
  }, [page]);
  if (!products || products.length === 0) {
    return (
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Alert
          severity="info"
          variant="outlined"
          sx={{
            "& .MuiAlert-message": { width: "100%" },
            mb: 3,
          }}
        >
          <AlertTitle sx={{ fontWeight: 600 }}>Ürün Bulunamadı</AlertTitle>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Seçilen kategoride ürününüz bulunamadı.
          </Typography>
          <Button variant="outlined" onClick={onBack} size="small">
            Geri Dön
          </Button>
        </Alert>
      </Paper>
    );
  }

  return (
    <Paper
      elevation={3}
      sx={{
        p: { xs: 2, sm: 3, md: 4 },
        borderRadius: 2,
        width: "100%",
        overflow: "hidden",
      }}
    >
      <Stack spacing={{ xs: 2, sm: 3 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: { xs: 1, sm: 2 },
          }}
        >
          <Typography
            variant="h5"
            color="primary.main"
            fontWeight="600"
            sx={{
              fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" },
            }}
          >
            Ürün Seçimi
          </Typography>

          {selectedProducts.length <= 100 ? (
            <Chip
              label={`${selectedProducts.length} ürün seçildi`}
              color="primary"
              variant="outlined"
              sx={{
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                height: { xs: 24, sm: 32 },
              }}
            />
          ) : (
            <Chip
              label={`${selectedProducts.length} ürün seçildi. Lütfen seçim sayısını 100 ve altı yapınız.`}
              color="warning"
              variant="outlined"
              sx={{
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                height: { xs: 24, sm: 32 },
              }}
            />
          )}
        </Box>

        <FormControlLabel
          control={
            <Checkbox
              checked={isAllCurrentPageSelected && displayedProducts.length > 0}
              onChange={(e) => handleSelectAll(e.target.checked)}
              color="primary"
              size="small"
            />
          }
          label={
            <Typography
              variant="subtitle1"
              fontWeight="500"
              sx={{
                fontSize: { xs: "0.875rem", sm: "1rem" },
              }}
            >
              Bu sayfadaki tüm ürünleri seç
            </Typography>
          }
          sx={{
            bgcolor: "grey.50",
            p: { xs: 0.5, sm: 1 },
            borderRadius: 1,
            width: "fit-content",
          }}
        />

        <Divider />

        <FormGroup>
          <Stack spacing={{ xs: 1, sm: 2 }}>
            {displayedProducts.map((product) => (
              <Card
                key={product.id}
                variant="outlined"
                sx={{
                  transition: "all 0.2s",
                  "&:hover": {
                    bgcolor: "grey.50",
                  },
                }}
              >
                <CardContent
                  sx={{
                    p: { xs: 1, sm: 2 },
                    "&:last-child": { pb: { xs: 1, sm: 2 } },
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedProducts.includes(product.id)}
                        onChange={(e) =>
                          handleProductChange(product.id, e.target.checked)
                        }
                        disabled={handleItemCheckbox(product)}
                        color="primary"
                        size="small"
                      />
                    }
                    label={
                      <Stack
                        direction={{ xs: "column", sm: "row" }}
                        alignItems={{ xs: "flex-start", sm: "center" }}
                        spacing={{ xs: 1, sm: 3 }}
                        width="100%"
                      >
                        {product.productImages?.length > 0 && (
                          <Box
                            component="img"
                            sx={{
                              width: { xs: 50, sm: 70 },
                              height: { xs: 50, sm: 70 },
                              objectFit: "cover",
                              borderRadius: 1,
                              boxShadow: 1,
                            }}
                            src={product.productImages[0].imageUrl}
                            alt={product.title}
                            referrerPolicy="no-referrer"
                          />
                        )}
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: selectedProducts.includes(product.id)
                              ? 600
                              : 400,
                            color: selectedProducts.includes(product.id)
                              ? "primary.main"
                              : "text.primary",
                            fontSize: { xs: "0.875rem", sm: "1rem" },
                            width: "100%",
                          }}
                        >
                          {product.title}
                        </Typography>

                        {handleItemCheckbox(product) && (
                          <Typography
                            variant="caption"
                            color="success.main"
                            sx={{
                              fontWeight: 500,
                              fontSize: { xs: "0.75rem", sm: "0.875rem" },
                              whiteSpace: { xs: "normal", sm: "nowrap" },
                            }}
                          >
                            {"Ürün pazaryerinde var veya süreci devam ediyor."}
                          </Typography>
                        )}
                      </Stack>
                    }
                    sx={{ width: "100%", mr: 0 }}
                  />
                </CardContent>
              </Card>
            ))}
          </Stack>
        </FormGroup>

        {totalCount > productsPerPage && (
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-between",
              alignItems: { xs: "flex-start", sm: "center" },
              gap: { xs: 2, sm: 0 },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: { xs: "100%", sm: "auto" },
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  mr: 2,
                  fontSize: { xs: "0.75rem", sm: "0.875rem" },
                }}
              >
                Sayfa başına ürün:
              </Typography>
              <Select
                value={pageSize}
                onChange={(e) => setPageSize(e.target.value)}
                size="small"
                sx={{
                  minWidth: { xs: 60, sm: 80 },
                  fontSize: { xs: "0.75rem", sm: "0.875rem" },
                }}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </Box>
            <Pagination
              count={pageCount}
              page={page}
              onChange={handlePageChange}
              color="primary"
              size="medium"
              sx={{
                "& .MuiPaginationItem-root": {
                  fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" },
                },
              }}
            />
          </Box>
        )}

        <Divider />

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
        >
          <Button
            variant="outlined"
            onClick={onBack}
            size="large"
            fullWidth={false}
            sx={{
              px: { xs: 2, sm: 4 },
              borderRadius: 2,
              width: { xs: "100%", sm: "auto" },
              fontSize: { xs: "0.875rem", sm: "1rem" },
            }}
          >
            Geri
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={() => onComplete(selectedProducts)}
            size="large"
            fullWidth={false}
            sx={{
              px: { xs: 2, sm: 4 },
              borderRadius: 2,
              width: { xs: "100%", sm: "auto" },
              fontSize: { xs: "0.875rem", sm: "1rem" },
            }}
            disabled={
              selectedProducts.length === 0 || selectedProducts.length > 100
            }
          >
            Devam ({selectedProducts.length})
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default ProductSelectionStep;
